import axios from "axios";
import { useEyeconxStore } from "../store/eyeconxStore";
const axiosNew = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
})

axiosNew.interceptors.request.use(
    (config) =>{
        const token = useEyeconxStore.getState().token
        if(token){
           // console.log("Token Set by Interceptor")
            config.headers.Authorization = "Bearer "+token;
        }
        return config;
    },
    (error) =>{
        console.log("Error in Interceptor")
        return Promise.reject(error);
    }
)
export default axiosNew